import React from 'react';
import { css } from 'emotion';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <div className={style.container}>
      <div className={style.copyright}>
        &copy;2020 Haardbeat by Julia |{' '}
        <Link to="/impressum" className={style.link}>
          Impressum
        </Link>
      </div>
    </div>
  );
}

const style = {
  container: css`
    height: 40px;
    display: flex;
    justify-content: space-around;
    background-color: #efefef;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
  `,
  copyright: css`
    line-height: 40px;
    font-size: 14px;
  `,
  link: css`
    color: #000000;
    text-decoration: none;
    &:hover {
      color: #d30e39;
    }
  `,
};

export default Footer;
